
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 29","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.21 17.688c.806.319 1.54.742 2.202 1.27a8.224 8.224 0 011.698 1.83 8.451 8.451 0 011.484 4.75v.764h-1.532v-.767a6.813 6.813 0 00-2.02-4.868 7.096 7.096 0 00-2.19-1.47 6.822 6.822 0 00-2.681-.551 6.817 6.817 0 00-4.868 2.02 7.104 7.104 0 00-1.47 2.19 6.81 6.81 0 00-.552 2.68v.766H1.75v-.767a8.267 8.267 0 011.484-4.747 8.607 8.607 0 013.9-3.098 5.238 5.238 0 01-.97-.863 5.524 5.524 0 01-.73-1.053c-.201-.378-.354-.78-.455-1.195a5.853 5.853 0 01-.166-1.294c0-.74.14-1.435.42-2.08a5.416 5.416 0 012.845-2.848 5.367 5.367 0 014.176-.012 5.416 5.416 0 012.847 2.847c.453 1.066.55 2.25.274 3.374a5.208 5.208 0 01-.465 1.197c-.205.38-.45.736-.73 1.064-.28.328-.604.613-.97.861zm-3.039-.574c.527 0 1.022-.1 1.484-.297a3.84 3.84 0 002.034-2.035c.208-.471.311-.97.311-1.495a3.74 3.74 0 00-1.125-2.691 4.171 4.171 0 00-1.22-.826 3.584 3.584 0 00-1.484-.312c-.525 0-1.02.1-1.482.298a3.882 3.882 0 00-2.048 2.047 3.734 3.734 0 00-.297 1.484c0 .525.1 1.02.297 1.482.202.462.473.87.816 1.22a3.794 3.794 0 002.716 1.125h-.002zM26.25 1.802v12.25h-3.063l-4.593 4.594v-4.594h-1.532V12.52h3.063v2.429l2.429-2.43h2.165V3.334H9.406v2.751c-.256.033-.512.073-.766.12-.26.05-.517.122-.765.216V1.802H26.25z"}})])
          )
        }
      }
    